// @ts-strict-ignore
import { Howl } from 'howler'
import { PlaylistItem, Collection, AudioSectionContainer } from 'mytours-read-common'
import { EventActionsEnum, EventParams, sendEvent } from '../logging/analytics'

export const calculatePercentage = (currentTime: number, duration?: number): number => {
	if (duration) {
		const progress = (currentTime / duration) * 100
		return Math.round(progress)
	}
	return 0
}

export const setCurrentSound = (
	audioId: number,
	container: AudioSectionContainer,
	fileId: number,
	sound: Howl,
): void => {
	const audioIndex = (window as any).stqryAudioFiles.findIndex(
		item =>
			item?.audioId === audioId &&
			item?.container?.id === container.id &&
			item?.container?.type === container.type &&
			item?.fileId === fileId,
	)

	const intemObject = {
		fileId,
		audioId,
		container,
		sound,
	}

	if (audioIndex > -1) {
		// don't replace the current audio object, because it causes player issues
	} else {
		;(window as any).stqryAudioFiles.push(intemObject)
	}
}

export const getCurrentSound = (audioId: number, container: AudioSectionContainer, fileId: number): Howl =>
	(window as any).stqryAudioFiles.find(
		item =>
			item.audioId === audioId &&
			item?.container?.id === container.id &&
			item?.container?.type === container.type &&
			item?.fileId === fileId,
	)?.sound

export const getAllSounds = (): Howl[] => (window as any).stqryAudioFiles.map(item => item.sound)

export const onBack15 = (
	audioId: number,
	container: AudioSectionContainer,
	fileId: number,
	callback: (newTime: number) => void,
): void => {
	const currentSound = getCurrentSound(audioId, container, fileId)
	if (!currentSound) {
		return
	}

	const seconds = currentSound.seek()

	// subtract 15 seconds
	const newTime = seconds - 15 < 0 ? 0 : seconds - 15

	currentSound.seek(newTime)

	callback(newTime)
}

export const onForward30 = (
	audioId: number,
	duration: number,
	container: AudioSectionContainer,
	fileId: number,
	callback: (newTime: number) => void,
): void => {
	const currentSound = getCurrentSound(audioId, container, fileId)
	if (!currentSound) {
		return
	}

	const seconds = currentSound.seek()

	// add 30 seconds
	let newTime = seconds + 30 > duration ? duration : seconds + 30

	if (newTime === duration) {
		newTime = 0
	}

	currentSound.seek(newTime)

	callback(newTime)
}

export const seekToPercentage = (
	audioId: number,
	percentage: number,
	duration: number,
	container: AudioSectionContainer,
	fileId: number,
): void => {
	if (percentage < 0 || percentage > 100) {
		return
	}

	const currentSound = getCurrentSound(audioId, container, fileId)

	if (currentSound && duration) {
		const newTime = duration * (percentage / 100)

		currentSound.seek(newTime)
	}
}

export const sendAnalyticsEvent = (
	currentAudio: PlaylistItem,
	collection: Collection,
	action: EventActionsEnum,
	options: EventParams = {},
): void => {
	const { audioTrack, container } = currentAudio || {}
	const { audio } = audioTrack || {}

	const sound = getCurrentSound(audio?.id, container, audio?.file?.id)
	const duration = sound?.duration()
	const currentTime = sound?.seek()
	const audioCurrentTime = options.audioCurrentTime && options.audioCurrentTime === -1 ? duration : currentTime

	sendEvent(action, {
		audioDuration: options.audioDuration || Math.floor(duration * 10) / 10,
		audioTitle: audio?.name,
		audioCurrentTime: Math.floor(audioCurrentTime * 10) / 10,
		audioPercent: options.audioPercent || Math.round((100 * currentTime) / duration),
		collection: collection?.name,
		collectionId: collection?.id,
		itemName: container?.screen?.name,
		screenSection: `${container?.id}-${container?.title}`,
	})
}
